import { statusMeta } from "../lib/format";

export default function StatusPill({ status, testid }) {
  const m = statusMeta(status);
  return (
    <span data-testid={testid} className={`pill ${m.className}`}>
      {m.label}
    </span>
  );
}
